import { EmptystateSearchNoResultsColored } from "components/icons/generated";
import PageLoading from "components/loading/PageLoading";
import SearchInput from "components/SearchInput";
import { SEARCH_PLACEHOLDERS } from "constants/searchPlaceholders";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import useErrorHandle from "hooks/useErrorHandle";

import IntegrationCard from "./components/Card";
import IntegrationsLayout from "./components/Layouts/IntegrationsLayout";
import IntegrationsListWrapper from "./components/ListWrapper";
import { useFilteredIntegrations } from "./hooks/useFilteredIntegrations";

const Integrations = () => {
  const { filteredIntegrations, loading, error } = useFilteredIntegrations();

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (loading) {
    return <PageLoading />;
  }

  return (
    <IntegrationsLayout
      integrations={filteredIntegrations}
      searchBar={
        <SearchInput filtersOrderSettingsKey="integrations" placeholder={SEARCH_PLACEHOLDERS.INTEGRATIONS} />
      }
    >
      {filteredIntegrations.length === 0 ? (
        <Box align="center" justify="center" fullHeight fullWidth padding="x-large">
          <EmptyState
            title="No results"
            caption="Don't give up! Check the spelling or try something less specific."
            icon={EmptystateSearchNoResultsColored}
          />
        </Box>
      ) : (
        <IntegrationsListWrapper>
          {filteredIntegrations.map((integration) => (
            <IntegrationCard key={integration.id} {...integration} />
          ))}
        </IntegrationsListWrapper>
      )}
    </IntegrationsLayout>
  );
};

export default Integrations;
